import type { ReactNode } from "react";
import { Text } from "./Text";

/** A label (+ optional hint) on the left, its control on the right. */
export interface SettingRowProps {
  title: string;
  hint?: string;
  children: ReactNode;
}

export function SettingRow({ title, hint, children }: SettingRowProps) {
  return (
    <div className="flex items-center justify-between gap-6 py-4">
      <div className="flex min-w-0 flex-col gap-0.5">
        <Text variant="ui" as="div">
          {title}
        </Text>
        {hint ? (
          <Text variant="body" className="text-[13px] text-ink-muted">
            {hint}
          </Text>
        ) : null}
      </div>
      <div className="shrink-0">{children}</div>
    </div>
  );
}
